import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import { queryAll } from '../utils/dom'

export const SELECTOR = '[data-rel="reference-modal"]'

export default class Page extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)

        const references = queryAll(SELECTOR)

        references.forEach(reference => {
            reference.addEventListener("click", this.openModal.bind(this))
        })
    }

    openModal(event) {
        const modal = Component.getFromElement("modal-reference")
        const reference = event.currentTarget
        const contentElement = reference.closest('[data-rel="content"]')

        if (modal && contentElement) {
            this.currentModal = modal

            modal.setContent(contentElement.outerHTML)

            modal.open()
        }
    }

    handleClick = event => {
        if (event.defaultPrevented) {
            return
        }

        const target = event.target.closest('a')

        if (!target) {
            return
        }

        const id = target.href.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        event.preventDefault()

        let offset = (target.dataset.offset) ? target.dataset.offset : 0

        const modalEl = element.closest('.Modal')
        if (modalEl) {
            const modal = Component.getFromElement(modalEl)
            if (modal.scrollContainer && modal.scrollContainer.scrollbar) {
                modal.scrollContainer.scrollbar.scrollIntoView(element, {
                    offsetTop: offset,
                    alignToTop: true
                })
            } else {
                const modalRect = modalEl.getBoundingClientRect()
                const targetRect = element.getBoundingClientRect()
                const diff = targetRect.top - modalRect.top
                modal.ref.scrollContainer.scrollTop = diff
            }
        } else {
            scrollToElement(element, { offset: offset })
        }

    }

}
